import moment from "moment-jalaali";
import React, { Component, Suspense } from "react";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import Loading from "./shared/loading";

const Login = React.lazy(() => import("./login"));
const Doctors = React.lazy(() => import("./doctors"));
const AddDoctor = React.lazy(() => import("./doctors/add-doctor"));
const AddDoctorsByFile = React.lazy(() => import("./doctors/add-doctors-by-file"));
const DoctorDetails = React.lazy(() => import("./doctor-details"));
const DoctorComments = React.lazy(() => import("./doctor-details/comments"));
const DoctorRatings = React.lazy(() => import("./doctor-details/ratings"));
const DefaultLayout = React.lazy(() => import("./layout/default-layout"));
const EditDoctorDetails = React.lazy(() => import("./doctor-details/edit-doctor-details"));
const Users = React.lazy(() => import("./users"));
const UserDetails = React.lazy(() => import("./user-details"));
const UserWallet = React.lazy(() => import("./user-details/wallet"));
const AddUser = React.lazy(() => import("./users/add-user"));
const Specialties = React.lazy(() => import("./specialties"));
const AddSpecialties = React.lazy(() => import("./specialties/add-specialty"));
const Professions = React.lazy(() => import("./professions"));
const AddProfessions = React.lazy(() => import("./professions/add-profession"));
const HealthTags = React.lazy(() => import("./health-tags"));
const AddHealthTag = React.lazy(() => import("./health-tags/add-health-tag"));
const EditUserDetails = React.lazy(() => import("./user-details/edit-user-details"));
const BookingsList = React.lazy(() => import("./bookings"));
const AddOffice = React.lazy(() => import("./doctor-details/office-details/add-office"));
const AddVirtualOffice = React.lazy(() => import("./doctor-details/office-details/add-virtual-office"));
const Cities = React.lazy(() => import("./cities"));
const Countries = React.lazy(() => import("./countries"));
const AddCountries = React.lazy(() => import("./countries/add-country"));
const EditCountries = React.lazy(() => import("./countries/edit-country"));
const addCity = React.lazy(() => import("./cities/add-city"));
const EditCity = React.lazy(() => import("./cities/edit-city"));
const States = React.lazy(() => import("./states"));
const AddStates = React.lazy(() => import("./states/add-state"));
const EditState = React.lazy(() => import("./states/edit-state"));
const Areas = React.lazy(() => import("./areas"));
const AddArea = React.lazy(() => import("./areas/add-area"));
const EditArea = React.lazy(() => import("./areas/edit-area"));
const Neighbourhoods = React.lazy(() => import("./neighbourhoods"));
const AddNeighbourhood = React.lazy(() => import("./neighbourhoods/add-neighbourhood"));
const EditNeighbourhood = React.lazy(() => import("./neighbourhoods/edit-neighbourhood"));
const Clinic = React.lazy(() => import("./clinics"));
const ClinicDetails = React.lazy(() => import("./clinics/clinic-details"));
const EditClinic = React.lazy(() => import("./clinics/edit-clinic"));
const AddClinic = React.lazy(() => import("./clinics/add-clinic"));
const Insurances = React.lazy(() => import("./insurances"));
const Practices = React.lazy(() => import("./practices"));
const AddPractices = React.lazy(() => import("./practices/add-practice"));
const AddInsurances = React.lazy(() => import("./insurances/add-insurance"));
const EditInsurances = React.lazy(() => import("./insurances/edit-insurance"));
const Messages = React.lazy(() => import("./messages"));
const Comments = React.lazy(() => import("./comments"));
const CommentsDoctors = React.lazy(() => import("./comments-doctors"));
const Cooperations = React.lazy(() => import("./cooperations"));
const CooperationsOld = React.lazy(() => import("./cooperations-old"));
const ContactMethod = React.lazy(() => import("./cooperations/contact"));
const AddContactMethod = React.lazy(() => import("./cooperations/contact/add-contact-method"));
const EditContactMethod = React.lazy(() => import("./cooperations/contact/edit-contact-method"));
const Holidays = React.lazy(() => import("./holidays"));
const AddHoliday = React.lazy(() => import("./holidays/add-holiday"));
const CooperationDetails = React.lazy(() => import("./cooperations/details"));
const CooperationOldDetails = React.lazy(() => import("./cooperations-old/details"));
const Introductions = React.lazy(() => import("./introductions"));
const IntroductionDetails = React.lazy(() => import("./introductions/details"));
const AddDoctorInsurance = React.lazy(() => import("./doctor-details/insurances/add-doctor-insurance"));
const DoctorInsurance = React.lazy(() => import("./doctor-details/insurances"));
const Images = React.lazy(() => import("./doctor-details/images"));
const OnlineConsult = React.lazy(() => import("./online-consult"));
const OnlineConsultPackagesList = React.lazy(() => import("./online-consult/packages/packages-list"));
const AddOnlineConsultPackages = React.lazy(() => import("./online-consult/packages/add-consult-package"));
const EditOnlineConsultPackages = React.lazy(() => import("./online-consult/packages/edit-consult-package"));
const Transactions = React.lazy(() => import("./transactions/transactions"));
const CurrenciesList = React.lazy(() => import("./transactions/currencies"));
const AddCurrency = React.lazy(() => import("./transactions/currencies/add-currency"));
const EditCurrency = React.lazy(() => import("./transactions/currencies/edit-currency"));
const PaymentGateway = React.lazy(() => import("./transactions/payment-gateways"));
const AddPaymentGateway = React.lazy(() => import("./transactions/payment-gateways/add-payment-gateway"));
const EditPaymentGateway = React.lazy(() => import("./transactions/payment-gateways/edit-payment-gateway"));
const Orders = React.lazy(() => import("./transactions/orders"));
const Consult = React.lazy(() => import("./online-consult/consult/consult"));
const Packages = React.lazy(() => import("./packages"));
const AddPackages = React.lazy(() => import("./packages/add-package"));
const EditPackages = React.lazy(() => import("./packages/edit-package"));
const DoctorPackages = React.lazy(() => import("./doctor-details/packages"));
const AddDoctorPackages = React.lazy(() => import("./doctor-details/packages/add-doctor-package"));
const EditDoctorPackages = React.lazy(() => import("./doctor-details/packages/edit-doctor-package"));
const TaskResults = React.lazy(() => import("./task-results"));
const TaskResultsDetails = React.lazy(() => import("./task-results/task-details"));
const DoctorWeightingsResults = React.lazy(() => import("./doctor-details/weighting-results"));
const DoctorWallet = React.lazy(() => import("./doctor-details/wallet"));
const DoctorsPackages = React.lazy(() => import("./doctors-packages"));
const DoctorsPackagePayments = React.lazy(() => import("./doctors-packages-payments"));
const Assessments = React.lazy(() => import("./assessments"));
const EditAssessment = React.lazy(() => import("./assessments/edit"));
const AddAssessment = React.lazy(() => import("./assessments/add"));
const BannerManagement = React.lazy(() => import("./banner-management"));
const Approaches = React.lazy(() => import("./approaches"));
const AddApproach = React.lazy(() => import("./approaches/add-approach"));

const GenerateTicket = React.lazy(() => import("./tickets/generate"));

const Tickets = React.lazy(() => import("./tickets/index.tsx"));
const Seo = React.lazy(() => import("./seo-settings"));
const AddSeo = React.lazy(() => import("./seo-settings/add-seo-setting"));
const EditSeo = React.lazy(() => import("./seo-settings/edit-seo-setting"));
const Notifications = React.lazy(() => import("./notifications"));
const AddNotification = React.lazy(() => import("./notifications/add-notification"));

moment.loadPersian({ dialect: "persian-modern" });
class App extends Component {
  render() {
    return (
      <Router>
        <Suspense fallback={<Loading />}>
          <Switch>
            <Route exact path="/" component={(props) => <Login {...props} />} />

            <DefaultLayout exact path="/doctors" component={Doctors} />
            <DefaultLayout exact path="/doctors/:id(\d+)" component={DoctorDetails} />
            <DefaultLayout exact path="/doctors/add" component={AddDoctor} />
            <DefaultLayout exact path="/doctors/add/file" component={AddDoctorsByFile} />
            <DefaultLayout exact path="/doctors/edit/:id(\d+)" component={EditDoctorDetails} />
            <DefaultLayout exact path="/doctors/images/:id(\d+)" component={Images} />
            <DefaultLayout exact path="/doctors/packages/:id(\d+)" component={DoctorPackages} />
            <DefaultLayout exact path="/doctors/packages/add/:id(\d+)" component={AddDoctorPackages} />
            <DefaultLayout exact path="/doctors/packages/edit/:id(\d+)" component={EditDoctorPackages} />
            <DefaultLayout exact path="/doctors/comments/:id(\d+)" component={DoctorComments} />
            <DefaultLayout exact path="/doctors/ratings/:id(\d+)" component={DoctorRatings} />
            <DefaultLayout exact path="/doctors/insurances/:id(\d+)" component={DoctorInsurance} />
            <DefaultLayout exact path="/doctors/insurances/add/:id(\d+)" component={AddDoctorInsurance} />
            <DefaultLayout exact path="/doctors/weightings-results/:id(\d+)" component={DoctorWeightingsResults} />
            <DefaultLayout exact path="/doctors/wallet/:id(\d+)" component={DoctorWallet} />

            <DefaultLayout exact path="/offices/add/:id(\d+)" component={AddOffice} />
            <DefaultLayout exact path="/offices/add/virtual/:id(\d+)" component={AddVirtualOffice} />

            <DefaultLayout exact path="/users" component={Users} />
            <DefaultLayout exact path="/users/:id(\d+)" component={UserDetails} />
            <DefaultLayout exact path="/users/add" component={AddUser} />
            <DefaultLayout exact path="/users/edit/:id(\d+)" component={EditUserDetails} />
            <DefaultLayout exact path="/users/wallet/:id(\d+)" component={UserWallet} />

            <DefaultLayout exact path="/bookings" component={BookingsList} />

            <DefaultLayout exact path="/specialties" component={Specialties} />
            <DefaultLayout exact path="/specialties/add" component={AddSpecialties} />

            <DefaultLayout exact path="/professions" component={Professions} />
            <DefaultLayout exact path="/professions/add" component={AddProfessions} />

            <DefaultLayout exact path="/health-tags" component={HealthTags} />
            <DefaultLayout exact path="/health-tags/add" component={AddHealthTag} />

            <DefaultLayout exact path="/approaches" component={Approaches} />
            <DefaultLayout exact path="/approaches/add" component={AddApproach} />

            <DefaultLayout exact path="/insurances" component={Insurances} />
            <DefaultLayout exact path="/insurances/add" component={AddInsurances} />
            <DefaultLayout exact path="/insurances/edit/:id(\d+)" component={EditInsurances} />

            <DefaultLayout exact path="/practices" component={Practices} />
            <DefaultLayout exact path="/practices/add" component={AddPractices} />

            <DefaultLayout exact path="/messages" component={Messages} hasToolbar={false} />
            <DefaultLayout exact path="/comments" component={Comments} hasToolbar={false} />
            <DefaultLayout exact path="/comments-doctors" component={CommentsDoctors} hasToolbar={false} />
            <DefaultLayout exact path="/notifications" component={Notifications} hasToolbar={false} />
            <DefaultLayout exact path="/notifications/add" component={AddNotification} />

            <DefaultLayout exact path="/cooperations" component={Cooperations} />
            <DefaultLayout exact path="/cooperations/:id(\d+)" component={CooperationDetails} />
            <DefaultLayout exact path="/cooperations/contacts-method" component={ContactMethod} />
            <DefaultLayout exact path="/cooperations/contacts-method/add" component={AddContactMethod} />
            <DefaultLayout exact path="/cooperations/contacts-method/edit/:id(\d+)" component={EditContactMethod} />

            <DefaultLayout exact path="/cooperationsOld" component={CooperationsOld} />
            <DefaultLayout exact path="/cooperationsOld/:id(\d+)" component={CooperationOldDetails} />

            <DefaultLayout exact path="/holidays" component={Holidays} />
            <DefaultLayout exact path="/holidays/add" component={AddHoliday} />

            <DefaultLayout exact path="/introductions" component={Introductions} />
            <DefaultLayout exact path="/introductions/:id(\d+)" component={IntroductionDetails} />

            <DefaultLayout exact path="/cities" component={Cities} />
            <DefaultLayout exact path="/cities/add" component={addCity} />
            <DefaultLayout exact path="/cities/edit/:id(\d+)" component={EditCity} />

            <DefaultLayout exact path="/states" component={States} />
            <DefaultLayout exact path="/states/add" component={AddStates} />
            <DefaultLayout exact path="/states/edit/:id(\d+)" component={EditState} />

            <DefaultLayout exact path="/areas" component={Areas} />
            <DefaultLayout exact path="/areas/add" component={AddArea} />
            <DefaultLayout exact path="/areas/edit/:id(\d+)" component={EditArea} />

            <DefaultLayout exact path="/neighbourhoods" component={Neighbourhoods} />
            <DefaultLayout exact path="/neighbourhoods/add" component={AddNeighbourhood} />
            <DefaultLayout exact path="/neighbourhoods/edit/:id(\d+)" component={EditNeighbourhood} />

            <DefaultLayout exact path="/countries" component={Countries} />
            <DefaultLayout exact path="/countries/add" component={AddCountries} />
            <DefaultLayout exact path="/countries/edit/:id(\d+)" component={EditCountries} />

            <DefaultLayout exact path="/clinics" component={Clinic} />
            <DefaultLayout exact path="/clinics/:id(\d+)" component={ClinicDetails} />
            <DefaultLayout exact path="/clinics/edit/:id(\d+)" component={EditClinic} />
            <DefaultLayout exact path="/clinics/add" component={AddClinic} />

            <DefaultLayout exact path="/online-consult/consult" component={OnlineConsult} />
            <DefaultLayout exact path="/online-consult/consult/:id(\d+)" component={Consult} />
            <DefaultLayout exact path="/online-consult/packages" component={OnlineConsultPackagesList} />
            <DefaultLayout exact path="/online-consult/packages/add" component={AddOnlineConsultPackages} />
            <DefaultLayout exact path="/online-consult/packages/edit/:id(\d+)" component={EditOnlineConsultPackages} />

            <DefaultLayout exact path="/transactions" component={Transactions} />

            <DefaultLayout exact path="/transactions/orders" component={Orders} />

            <DefaultLayout exact path="/transactions/currencies" component={CurrenciesList} />
            <DefaultLayout exact path="/transactions/currencies/add" component={AddCurrency} />
            <DefaultLayout exact path="/transactions/currencies/edit/:id(\d+)" component={EditCurrency} />

            <DefaultLayout exact path="/transactions/payment-gateways" component={PaymentGateway} />
            <DefaultLayout exact path="/transactions/payment-gateways/add" component={AddPaymentGateway} />
            <DefaultLayout exact path="/transactions/payment-gateways/edit/:id(\d+)" component={EditPaymentGateway} />

            <DefaultLayout exact path="/packages" component={Packages} />
            <DefaultLayout exact path="/packages/add" component={AddPackages} />
            <DefaultLayout exact path="/packages/edit/:id(\d+)" component={EditPackages} />

            <DefaultLayout exact path="/task-results" component={TaskResults} hasToolbar={false} />
            <DefaultLayout
              exact
              path="/task-results/:taskId([\w-]+)"
              component={TaskResultsDetails}
              hasToolbar={false}
            />

            <DefaultLayout exact path="/doctors/packages" component={DoctorsPackages} hasToolbar={false} />
            <DefaultLayout
              exact
              path="/doctors/packages/payment"
              component={DoctorsPackagePayments}
              hasToolbar={false}
            />

            <DefaultLayout exact path="/tickets" component={Tickets} hasToolbar={false} />
            <DefaultLayout exact path="/generate-ticket" component={GenerateTicket} hasToolbar={false} />

            <DefaultLayout exact path="/seo-settings" component={Seo} />
            <DefaultLayout exact path="/seo-settings/add" component={AddSeo} />
            <DefaultLayout exact path="/seo-settings/edit/:id(\d+)" component={EditSeo} />

            <DefaultLayout exact path="/assessments" component={Assessments} />
            <DefaultLayout exact path="/assessments/edit/:id(\d+)" component={EditAssessment} />
            <DefaultLayout exact path="/assessments/add" component={AddAssessment} />
            <DefaultLayout exact path="/banner-management" component={BannerManagement} hasToolbar={false} />
          </Switch>
        </Suspense>
      </Router>
    );
  }
}

export default App;
